/* SessionAnimatedIndicator.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbkfkE%7Bdisplay%3Ainline-grid%7D%0A._2iEGP28wUV%7Bgrid-template-columns%3Aminmax(0%2C1fr)%7D%0A._0ca6V78wUV%7Bgrid-template-rows%3Aminmax(0%2C1fr)%7D%0A._0hPCNLDIqT%7Balign-items%3Acenter%7D%0A._0pI6nMDIqT%7Bjustify-items%3Acenter%7D%0A._39xV02oWWg%7Bwidth%3A24px%7D%0A._0jFU0VoWWg%7Bheight%3A24px%7D%0A._3YEZNOdnbC%7Bflex-shrink%3A0%7D%0A._1RrJLit2nV%7Bvertical-align%3Amiddle%7D%0A._39xV02xpxF%7Bwidth%3A9pt%7D%0A._0jFU0VxpxF%7Bheight%3A9pt%7D%0A._1xC2CJYhv7%7Bgrid-area%3A1%2F1%7D%0A._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D%0A._37wbyuDIqT%7Bjustify-content%3Acenter%7D%0A._0yKXXaDIqT%7Btransform-origin%3Acenter%7D%0A%40keyframes%20kitaa44%7B0%25%7Bopacity%3A0%3Btransform%3Ascale(.2)%7D45%25%7Bopacity%3A0%3Btransform%3Ascale(.2)%7Dto%7Bopacity%3A1%3Btransform%3Ascale(1)%7D%7D%0A._1gBiby3M2A%7Banimation-name%3Akitaa44%7D%0A._0nFVCGpCLV%7Banimation-duration%3Avar(--ds-duration-xxlong%2C.6s)%7D%0A._43vdfTjwM9%7Banimation-timing-function%3Avar(--ds-easing-out-practical%2Ccubic-bezier(.4%2C1%2C.6%2C1))%7D%0A%40media%20(prefers-reduced-motion%3Areduce)%7B._0LqqFdYbGa%7Banimation-name%3Anone%7D%7D%0A%40keyframes%20k825btf%7B0%25%7Bopacity%3A1%3Btransform%3Ascale(1)%7D55%25%7Bopacity%3A0%3Btransform%3Ascale(.2)%7Dto%7Bopacity%3A0%3Btransform%3Ascale(.2)%7D%7D%0A._1gBiby1nu3%7Banimation-name%3Ak825btf%7D%0A._43vdfTyNAO%7Banimation-timing-function%3Avar(--ds-easing-in-practical%2Ccubic-bezier(.6%2C0%2C.8%2C.6))%7D%0A._3Y6bKpgRhm%7Banimation-fill-mode%3Aforwards%7D%0A%40media%20(prefers-reduced-motion%3Areduce)%7B._3NPCoqYbGa%7Bdisplay%3Anone%7D%7D%0A._3iDTPbvLZJ%7Bdisplay%3Ablock%7D%0A._1UtDYz4YkS%7Bcolor%3Avar(--ds-icon-subtle%2C%23505258)%7D%0A._1rdFvh98eZ%7Bfill%3AcurrentColor%7D%0A%40keyframes%20k7rupus%7B0%25%7Btransform%3Arotate(0deg)%7Dto%7Btransform%3Arotate(1turn)%7D%7D%0A._2WT4cdQGz1%7Btransform-box%3Aview-box%7D%0A._1gBibySaH4%7Banimation-name%3Ak7rupus%7D%0A._0nFVCGI1la%7Banimation-duration%3A9.78s%7D%0A._1jakNnK3Ew%7Banimation-delay%3A-2.445s%7D%0A._43vdfTHVQb%7Banimation-timing-function%3Alinear%7D%0A._03m2nySHWH%7Banimation-iteration-count%3Ainfinite%7D%0A._4Cu53BeMto%7Banimation-play-state%3Arunning%7D%0A._4Cu53BP4vI%7Banimation-play-state%3Apaused%7D%0A._43vdfTHBJp%7Banimation-timing-function%3Acubic-bezier(.4%2C0%2C.2%2C1)%7D%0A._4Cu53BOLYo%7Banimation-play-state%3Ainherit%7D%0A%40keyframes%20ktea16z%7B0%25%7Btransform%3Atranslate(0%2C-1.3px)%3Bopacity%3A1%7D5%25%7Btransform%3Atranslate(0%2C-1.3px)%3Bopacity%3A1%7D50%25%7Btransform%3Atranslate(0%2C-1.3px)%3Bopacity%3A1%7D55%25%7Btransform%3Atranslate(0%2C-1.3px)%3Bopacity%3A1%7Dto%7Btransform%3Atranslate(0%2C-1.3px)%3Bopacity%3A1%7D25%25%7Btransform%3Atranslate(0%2C-5.5px)%3Bopacity%3A.82%7D40%25%7Btransform%3Atranslate(0%2C-5.5px)%3Bopacity%3A.82%7D75%25%7Btransform%3Atranslate(0%2C-5.5px)%3Bopacity%3A.82%7D90%25%7Btransform%3Atranslate(0%2C-5.5px)%3Bopacity%3A.82%7D32%25%7Btransform%3Atranslate(0%2C-5.5px)%3Bopacity%3A.66%7D82%25%7Btransform%3Atranslate(0%2C-5.5px)%3Bopacity%3A.66%7D%7D%0A._1gBibyLPSh%7Banimation-name%3Aktea16z%7D%0A._1VJPcaPXce%7Btransform%3Atranslate(0%2C-5.5px)%7D%0A._1YKVNsXrR1%7Bopacity%3A.82%7D%0A%40keyframes%20kxqh4z%7B0%25%7Btransform%3Atranslate(1.126px%2C-.65px)%3Bopacity%3A1%7D5%25%7Btransform%3Atranslate(1.126px%2C-.65px)%3Bopacity%3A1%7D50%25%7Btransform%3Atranslate(1.126px%2C-.65px)%3Bopacity%3A1%7D55%25%7Btransform%3Atranslate(1.126px%2C-.65px)%3Bopacity%3A1%7Dto%7Btransform%3Atranslate(1.126px%2C-.65px)%3Bopacity%3A1%7D25%25%7Btransform%3Atranslate(4.763px%2C-2.75px)%3Bopacity%3A.62%7D40%25%7Btransform%3Atranslate(4.763px%2C-2.75px)%3Bopacity%3A.62%7D75%25%7Btransform%3Atranslate(4.763px%2C-2.75px)%3Bopacity%3A.62%7D90%25%7Btransform%3Atranslate(4.763px%2C-2.75px)%3Bopacity%3A.62%7D32%25%7Btransform%3Atranslate(4.763px%2C-2.75px)%3Bopacity%3A.78%7D82%25%7Btransform%3Atranslate(4.763px%2C-2.75px)%3Bopacity%3A.78%7D%7D%0A._1gBiby9bWs%7Banimation-name%3Akxqh4z%7D%0A._1VJPcaJZVP%7Btransform%3Atranslate(4.763px%2C-2.75px)%7D%0A._1YKVNsCfZC%7Bopacity%3A.62%7D%0A%40keyframes%20kw08g55%7B0%25%7Btransform%3Atranslate(1.126px%2C.65px)%3Bopacity%3A1%7D5%25%7Btransform%3Atranslate(1.126px%2C.65px)%3Bopacity%3A1%7D50%25%7Btransform%3Atranslate(1.126px%2C.65px)%3Bopacity%3A1%7D55%25%7Btransform%3Atranslate(1.126px%2C.65px)%3Bopacity%3A1%7Dto%7Btransform%3Atranslate(1.126px%2C.65px)%3Bopacity%3A1%7D25%25%7Btransform%3Atranslate(4.763px%2C2.75px)%3Bopacity%3A.78%7D40%25%7Btransform%3Atranslate(4.763px%2C2.75px)%3Bopacity%3A.78%7D75%25%7Btransform%3Atranslate(4.763px%2C2.75px)%3Bopacity%3A.78%7D90%25%7Btransform%3Atranslate(4.763px%2C2.75px)%3Bopacity%3A.78%7D32%25%7Btransform%3Atranslate(4.763px%2C2.75px)%3Bopacity%3A.6%7D82%25%7Btransform%3Atranslate(4.763px%2C2.75px)%3Bopacity%3A.6%7D%7D%0A._1gBibyNgO8%7Banimation-name%3Akw08g55%7D%0A._1VJPca3hOv%7Btransform%3Atranslate(4.763px%2C2.75px)%7D%0A._1YKVNsOmsb%7Bopacity%3A.78%7D%0A%40keyframes%20k1jgn9oo%7B0%25%7Btransform%3Atranslate(0%2C1.3px)%3Bopacity%3A1%7D5%25%7Btransform%3Atranslate(0%2C1.3px)%3Bopacity%3A1%7D50%25%7Btransform%3Atranslate(0%2C1.3px)%3Bopacity%3A1%7D55%25%7Btransform%3Atranslate(0%2C1.3px)%3Bopacity%3A1%7Dto%7Btransform%3Atranslate(0%2C1.3px)%3Bopacity%3A1%7D25%25%7Btransform%3Atranslate(0%2C5.5px)%3Bopacity%3A.58%7D40%25%7Btransform%3Atranslate(0%2C5.5px)%3Bopacity%3A.58%7D75%25%7Btransform%3Atranslate(0%2C5.5px)%3Bopacity%3A.58%7D90%25%7Btransform%3Atranslate(0%2C5.5px)%3Bopacity%3A.58%7D32%25%7Btransform%3Atranslate(0%2C5.5px)%3Bopacity%3A.72%7D82%25%7Btransform%3Atranslate(0%2C5.5px)%3Bopacity%3A.72%7D%7D%0A._1gBibytN0H%7Banimation-name%3Ak1jgn9oo%7D%0A._1VJPcavPiU%7Btransform%3Atranslate(0%2C5.5px)%7D%0A._1YKVNsviwg%7Bopacity%3A.58%7D%0A%40keyframes%20kcfhx50%7B0%25%7Btransform%3Atranslate(-1.126px%2C.65px)%3Bopacity%3A1%7D5%25%7Btransform%3Atranslate(-1.126px%2C.65px)%3Bopacity%3A1%7D50%25%7Btransform%3Atranslate(-1.126px%2C.65px)%3Bopacity%3A1%7D55%25%7Btransform%3Atranslate(-1.126px%2C.65px)%3Bopacity%3A1%7Dto%7Btransform%3Atranslate(-1.126px%2C.65px)%3Bopacity%3A1%7D25%25%7Btransform%3Atranslate(-4.763px%2C2.75px)%3Bopacity%3A.8%7D40%25%7Btransform%3Atranslate(-4.763px%2C2.75px)%3Bopacity%3A.8%7D75%25%7Btransform%3Atranslate(-4.763px%2C2.75px)%3Bopacity%3A.8%7D90%25%7Btransform%3Atranslate(-4.763px%2C2.75px)%3Bopacity%3A.8%7D32%25%7Btransform%3Atranslate(-4.763px%2C2.75px)%3Bopacity%3A.66%7D82%25%7Btransform%3Atranslate(-4.763px%2C2.75px)%3Bopacity%3A.66%7D%7D%0A._1gBiby6Om1%7Banimation-name%3Akcfhx50%7D%0A._1VJPcazcNU%7Btransform%3Atranslate(-4.763px%2C2.75px)%7D%0A._1YKVNsuIQN%7Bopacity%3A.8%7D%0A%40keyframes%20k1u0pmmf%7B0%25%7Btransform%3Atranslate(-1.126px%2C-.65px)%3Bopacity%3A1%7D5%25%7Btransform%3Atranslate(-1.126px%2C-.65px)%3Bopacity%3A1%7D50%25%7Btransform%3Atranslate(-1.126px%2C-.65px)%3Bopacity%3A1%7D55%25%7Btransform%3Atranslate(-1.126px%2C-.65px)%3Bopacity%3A1%7Dto%7Btransform%3Atranslate(-1.126px%2C-.65px)%3Bopacity%3A1%7D25%25%7Btransform%3Atranslate(-4.763px%2C-2.75px)%3Bopacity%3A.6%7D40%25%7Btransform%3Atranslate(-4.763px%2C-2.75px)%3Bopacity%3A.6%7D75%25%7Btransform%3Atranslate(-4.763px%2C-2.75px)%3Bopacity%3A.6%7D90%25%7Btransform%3Atranslate(-4.763px%2C-2.75px)%3Bopacity%3A.6%7D32%25%7Btransform%3Atranslate(-4.763px%2C-2.75px)%3Bopacity%3A.76%7D82%25%7Btransform%3Atranslate(-4.763px%2C-2.75px)%3Bopacity%3A.76%7D%7D%0A._1gBibyuy2o%7Banimation-name%3Ak1u0pmmf%7D%0A._1VJPcaxoCZ%7Btransform%3Atranslate(-4.763px%2C-2.75px)%7D%0A._1YKVNsH9dr%7Bopacity%3A.6%7D");






























































import React, { useCallback, useState } from 'react';
import { useIntl } from 'react-intl';
import { cx } from '@atlaskit/css';
import StrokeWeightLargeIcon from '@atlaskit/icon/core/stroke-weight-large';
import { Box } from '@atlaskit/primitives/compiled/box';
import { messages } from './messages';

/**
 * IMPORTANT — intentional internal copy for ROVOFE-4135.
 * Adapted from agent-sessions/agent-session-status/src/AgentSessionWorkingOrb.tsx and
 * AgentSessionStatusIcon.tsx. Importing that package propagates workspace manifest changes
 * across consuming products and introduces a dependency direction that needs reassessment.
 * Keep the orb and its swap animation isolated here, without a public package export, so this
 * change can ship without expanding its dependency and approval scope. Preserve the source
 * motion timings and reduced-motion behavior when maintaining this copy.
 * TODO: Reassess lower-level ownership and consolidate with agent-session-status when feasible.
 */
type IndicatorType = 'working' | 'dot';
type IndicatorTransitionState = {
  current: IndicatorType;
  outgoing: IndicatorType | null;
};

/** Internal visual used by SessionStatusIndicator; sizes are intentionally fixed. */
export function SessionAnimatedIndicator({
  indicatorType
}: {
  indicatorType: IndicatorType;
}): React.JSX.Element {
  const {
    formatMessage
  } = useIntl();
  const [transition, setTransition] = useState<IndicatorTransitionState>(() => ({
    current: indicatorType,
    outgoing: null
  }));
  if (transition.current !== indicatorType) {
    setTransition({
      current: indicatorType,
      outgoing: transition.current
    });
  }
  const handleAnimationEnd = useCallback((event: React.AnimationEvent<HTMLSpanElement>) => {
    if (event.currentTarget === event.target) {
      setTransition(current => ({
        ...current,
        outgoing: null
      }));
    }
  }, []);
  const layers = transition.outgoing ? [{
    indicatorType: transition.outgoing,
    isOutgoing: true
  }, {
    indicatorType: transition.current,
    isOutgoing: false
  }] : [{
    indicatorType: transition.current,
    isOutgoing: false
  }];
  return <Box as="span" xcss={cx(styles.slot, transition.current === 'dot' && styles.slotSmall)}>
			{layers.map(({
      indicatorType: layerIndicatorType,
      isOutgoing
    }) => <Box key={layerIndicatorType} as="span" aria-hidden={isOutgoing || undefined} xcss={cx(styles.layer, isOutgoing ? styles.exit : transition.outgoing && styles.enter)} onAnimationEnd={handleAnimationEnd}>
					{layerIndicatorType === 'working' ? <SessionWorkingOrb label={formatMessage(messages.working)} paused={!isOutgoing && transition.outgoing !== null} /> : <StrokeWeightLargeIcon label={formatMessage(messages.needsInput)} size="small" spacing="none" color={"var(--ds-icon-information, #357DE8)"} />}
				</Box>)}
		</Box>;
}
type SessionWorkingOrbProps = {
  label: string;
  /** Freezes the animation at its expanded state for transitions and deterministic visual testing. */
  paused?: boolean;
};

/**
 * Animated working-status glyph. Reduced-motion users see the static expanded orb.
 */
function SessionWorkingOrb({
  label,
  paused = false
}: SessionWorkingOrbProps): React.JSX.Element {
  return <svg viewBox="0 0 16 16" width={16} height={16} role="img" aria-label={label} focusable="false" className={ax([orbStyles.glyph])}>
			<g className={ax([orbStyles.rotation, paused && orbStyles.paused])}>
				<circle cx="8" cy="8" r="1.2" className={ax([orbStyles.dot, orbStyles.top])} />
				<circle cx="8" cy="8" r="1.2" className={ax([orbStyles.dot, orbStyles.topRight])} />
				<circle cx="8" cy="8" r="1.2" className={ax([orbStyles.dot, orbStyles.bottomRight])} />
				<circle cx="8" cy="8" r="1.2" className={ax([orbStyles.dot, orbStyles.bottom])} />
				<circle cx="8" cy="8" r="1.2" className={ax([orbStyles.dot, orbStyles.bottomLeft])} />
				<circle cx="8" cy="8" r="1.2" className={ax([orbStyles.dot, orbStyles.topLeft])} />
			</g>
		</svg>;
}
const rotate = null;

// Start at 25%, the beginning of the expanded plateau that runs until 40%.
const expandedAnimationDelay = '-2.445s';
const top = null;
const topRight = null;
const bottomRight = null;
const bottom = null;
const bottomLeft = null;
const topLeft = null;
const orbStyles = {
  glyph: "_3iDTPbvLZJ _1UtDYz4YkS _1rdFvh98eZ",
  rotation: "_0yKXXaDIqT _2WT4cdQGz1 _1gBibySaH4 _0nFVCGI1la _1jakNnK3Ew _43vdfTHVQb _03m2nySHWH _4Cu53BeMto _0LqqFdYbGa",
  paused: "_4Cu53BP4vI",
  dot: "_0nFVCGI1la _1jakNnK3Ew _43vdfTHBJp _03m2nySHWH _4Cu53BOLYo _0LqqFdYbGa",
  top: "_1gBibyLPSh _1VJPcaPXce _1YKVNsXrR1",
  topRight: "_1gBiby9bWs _1VJPcaJZVP _1YKVNsCfZC",
  bottomRight: "_1gBibyNgO8 _1VJPca3hOv _1YKVNsOmsb",
  bottom: "_1gBibytN0H _1VJPcavPiU _1YKVNsviwg",
  bottomLeft: "_1gBiby6Om1 _1VJPcazcNU _1YKVNsuIQN",
  topLeft: "_1gBibyuy2o _1VJPcaxoCZ _1YKVNsH9dr"
};
const growIndicator = null;
const shrinkIndicator = null;
const styles = {
  slot: "_3iDTPbkfkE _2iEGP28wUV _0ca6V78wUV _0hPCNLDIqT _0pI6nMDIqT _39xV02oWWg _0jFU0VoWWg _3YEZNOdnbC _1RrJLit2nV",
  slotSmall: "_39xV02xpxF _0jFU0VxpxF",
  layer: "_1xC2CJYhv7 _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0yKXXaDIqT",
  enter: "_1gBiby3M2A _0nFVCGpCLV _43vdfTjwM9 _0LqqFdYbGa",
  exit: "_1gBiby1nu3 _0nFVCGpCLV _43vdfTyNAO _3Y6bKpgRhm _3NPCoqYbGa"
};